import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[festival-slug]/[locale]/(rest)/schedule/components/ScheduleFiltration.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[festival-slug]/[locale]/(rest)/schedule/components/ScheduleList.tsx");
